// select options
$(document).ready(function () {
    $(".vimeo_player").fancybox({
      // solves some issues with streamed media
      iframe: {
          preload: false,
        css: {
          margin: "0",
        }
      },
  	});
  
  	// accordion settings
    $('.accordion > dt > a').click(function() {
      if ($(this).parent().next().css('display') != "block") {
        $(this).addClass('active');
        $(this).parent().next().slideDown();
      } else {
        $(this).removeClass('active');
        $(this).parent().next().slideUp();
      }

      return false;
    });

//     toggleSidebar();
    removeItemFromCart();
  	wishlistProductItem();
  	checkPickupInStore();
});


function checkPickupInStore() {
  	let isPickup = new RegExp('[\?&]pickup=([^&#]*)').exec(window.location.href);
    if (isPickup) {
      
     $.cookie('pickup_in_store', 'pickup_in_store', {
        expires: 1,
        path: '/'
      });
  	}
}

function notifyAddCart($i){
  $('.loading').hide();
}

function notifyAddCartFail($i){
  $('.loading').hide();
  $.jGrowl($i,{
    life: 3000
  });
}

var filter_products = {
    product_tags : {},
    addProduct : function(variant_id, tags) {
        var self = this;
        if( tags !==undefined && tags.length > 0) {
            tags.forEach(function(tag) {
               if (self.product_tags[tag] == undefined) {
                   self.product_tags[tag] = {
                       products: []
                   }
               }
                self.product_tags[tag].products.push(variant_id);
            });
        }
    },
    getProducts : function(selected_tag){

        var return_products = {};
        var self = this;

        if( Object.keys(self.product_tags).length > 0) {
            Object.keys(self.product_tags).forEach(function (tag) {
                tagproducts = self.product_tags[tag];

                if( tagproducts.products !== undefined && tagproducts.products.length > 0 ) {

                    if ( selected_tag !== undefined && selected_tag.toString().trim().length > 0 ) {
                        if (selected_tag.toLowerCase().trim() !== tag.toLowerCase().trim() ){
                            return;
                        }
                    }

                    tagproducts.products.forEach(function(variant_id){
                       return_products[variant_id] = variant_id;
                    });
                }
            });
        }

        var variants = [];

        Object.keys(return_products).forEach(function(key) {
            variants.push(key);
        });

        return variants;
    }
}

/* Ajax Add To Cart */

function addToCart(id){
  /* Show loading */
  $('.loading').show();

  var productId = $('#'+id).find("[name='id']").val();

  // Hide Modal
  $('.modal').modal('hide');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: {
      quantity: 1,
      id: productId,

    },
    dataType: 'json',
    error: addToCartFail,
    success: function(jqXHR, textStatus, errorThrown) {
      addToCartSuccess([], jqXHR, textStatus, errorThrown);
    },
    cache: false
  });

}


function addToCartMany(e,variants,cb,qty = 1){
    if (typeof e !== 'undefined') e.preventDefault();

    /* Show loading */
    $('.loading').show();

    var $this = $(this);

    if(variants === null || variants === undefined || Object.keys(variants).length < 1 ) {
        addToCartFail()
    }

    var quantities = [];
    var products = [];
    var items = [];

    Object.keys(variants).forEach(function(variant) {
        quantities.push(qty);
        products.push(variant);
        items.push( {
          quantity: qty, id: variant
        })
    });

    $this.addClass('disabled');

    var form = $this.parents('form');

    // Hide Modal
    $('.modal').modal('hide');

    $.ajax({
        method: "POST",
        url: "/cart/add.js",
        data: {
            items: items
        },
        dataType: "json",
        error: function(jqXHR, textStatus, errorThrown) { 
          addToCartFail(jqXHR, textStatus, errorThrown); 
          if (!!cb) {
            cb(false);
          }
      },
        success: function(jqXHR, textStatus, errorThrown) {
            addToCartSuccess(variants, jqXHR, textStatus, errorThrown);
            if (!!cb) {
                cb(true);
            }
        },
        cache: false
    });
}

function GetCartItems( cart, variants ) {

    // Get Cart
    var data = {
        total: 0.0,
        contents: []
    };

    // Get total
    // data.total = Shopify.formatMoney(cart.total_price).replace(",","");

    // Setup line items
    var variantList = [];
    for(var i=0; i<cart.items.length; i++) {
        var item = cart.items[i];
        var qty = 0;
        var product_id = "";

        if ( variants !== undefined && Object.keys(variants).length > 0 ) {

            // Check if this item was in the add items list
            Object.keys(variants).forEach( function ( variant_id ) {
                if ( variant_id === item.variant_id.toString() ) {
                    variantList.push(variant_id);
                    // Found it
                    product_id = variant_id;
                    qty = 1;//variants[variant_id];
                }
            });
        } else {
            qty = parseInt(item.quantity);
        }

        // Check if QTY > 0
        if ( qty > 0 ) {

            // Determine total
            var discounted_price = parseFloat(Shopify.formatMoney(item.discounted_price).replace(",","").replace("$","")) * qty;

            // Update total
            data.total += discounted_price;

            // Add it to array
            data.contents.push( {
                quantity: qty,
                id: product_id,
                item_price: parseFloat(parseFloat(discounted_price).toFixed(2))
            } );

        }
    }

    data.content_ids = variantList;

    return data;
}

function addToCartSuccess (variants, jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');
  $('.add-to-cart-many').removeClass('disabled');

  $.ajax({
    method: 'GET',
    url: '/cart.js',
    complete: function (response) {
      if (response.status === 200) {
      	updateCart(JSON.parse(response.responseText));
      }
    }
//     dataType: 'jsonp'
  });

}

function updateCart(cart) {

  saveCartItemCounts(cart);

  // update badge of cart icon
  const numberOfCartItems = cart ? cart.items.length : 0;

  $(".cartCount").text(numberOfCartItems)

  Shopify.updateCartInfo(cart, '#dropdown-cart .has-items .mini-products-list');
  Shopify.updateCartInfo(cart, '.cart-sb .has-items .mini-products-list');

  $("html").addClass('cart-show');

  showPaymentMethods();

  toggleSidebar();
  removeItemFromCart();
}

function removeItemFromCart() {
  	var dropdownCart = $('.cart-sb .mini-products-list')
    var btnRemove = dropdownCart.find('.btn-remove');

    btnRemove.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var productId = $(this).parents('.item').attr('id');
      productId = productId.match(/\d+/g);

      Shopify.removeItem(productId, function (cart) {
        updateCart(cart);
      });
    });
}


function FBPixel( pixelType, data  ) {
    switch ( pixelType ) {

        case "InitiateCheckout":

            $.getJSON('/cart.js', function(cart) {
                var data = GetCartItems( cart );
                fbq('track', 'InitiateCheckout', {
                    value: data.total,
                    currency: 'USD',
                });
            });
            break;
        case "AddToCart":

            if ( data !== undefined && data.total > 0 ) {
                fbq('track', 'AddToCart', {
                    value: data.total,
                    content_type : 'product',
                    currency: 'USD',
                    contents: data.contents,
                    content_ids: data.content_ids
                });
            }

            break;

        case "Purchase":

            fbq('track', 'Purchase', {
                value: 1,
                currency: 'USD',
                content_type : 'product',
                contents: [
                    {
                        quantity: 1,
                        item_price: 10
                    }
                ],
            });

            break;
        case "AddPaymentInfo":
            fbq('track', 'AddPaymentInfo');
            break;
        case "AddToWishlist":
            fbq('track', 'AddToWishlist', {
                value: 1,
                currency: 'USD',
            });
            break;
        case "Search":
            fbq('track', 'Search');
            break;
        case "SubmitApplication":
            fbq('track', 'SubmitApplication');
            break;
        case "FindLocation":
            fbq('track', 'FindLocation');
            break;
        case "Contact":
            fbq('track', 'Contact');
            break;
    }

}


function addToCartFail(jqXHR, textStatus, errorThrown){
    $('.add-to-cart').removeClass('disabled');
    $('.add-to-cart-many').removeClass('disabled');

    var response = $.parseJSON(jqXHR.responseText);

    var $i = '<div class="error">'+ response.description +'</div>';
    notifyAddCartFail($i);
}


function showPaymentMethods () {
  var cartItemCounts = window.localStorage.getItem("cartItemCounts", null);
  if (!cartItemCounts || cartItemCounts == 'undefined' || cartItemCounts == 0) {
    $(".cart-sb .has-items").hide();
    $(".cart-sb .no-items").show();
  } else {
    $(".cart-sb .has-items").show();
    $(".cart-sb .no-items").hide();
  }
}

function saveCartItemCounts(cart) {
  const cartItemCounts = cart ? cart.items.length : 0;
  window.localStorage.setItem("cartItemCounts", cartItemCounts);
}

function getCartItemCounts(cart) {
  var cartItemCounts = window.localStorage.getItem("cartItemCounts");
  if (!cartItemCounts || cartItemCounts == 0) {
    return 0;
  } else {
    return parseInt(cartItemCounts);
  }
}

function wishlistProductItem() {
  $(document).on('click','#ProductSection-product-template-default .groups-btn .wishlist-btn',function(e){
    $('.loading').show();

    var $this = $(this);
    $this.addClass('disabled');

    e.preventDefault();
    var form = $(this).closest('form');
    var i = form.parents(".product-wrapper");


    $.ajax({
      type: "POST",
      url: "/contact",
      data: form.serialize(),
      beforeSend: function() {
        //to do
      },
      success: function(n) {
        alert('successfully added!');

      },
      error: function() {
        // to do
        alert('Error!')
      }
    })
  })
};

// alternatively, if you don't want to use a polyfil
function imgURL(src, size) {
  // remove any current image size then add the new image size
  return src
    .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    })
  ;
}

function initializeSlick(domObj) {
	$(domObj).not('.slick-initialized').slick({
      infinite: true,
      speed: 1000,

      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      arrows: true,
      autoplay: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        }
      ]
    });
}

$(window).load(function () {

    // Check if there's hash tag
    var hashtag = window.top.location.hash.substr(1);
    if (!!hashtag && hashtag.length > 0) {

        // var el = $()

        // $(this).siblings().removeClass('active');
        // $(this).addClass('active');

        // show relevant section
        $(".tab-collection-panel").hide();

        var collectionName = "#"+ hashtag + "-panel";
        $(collectionName).show();

        // show relevant navbar
      
        $(".custom-desktop-nav").removeClass('active');

        var nativeName = "#"+ hashtag + "_desktop_nav";
        $(nativeName).addClass('active');
      
      	// Update link
        $(".header-collection-link").removeClass('active');
        var linkName = "#"+ hashtag + "-link";
        $(linkName).addClass('active');

       initializeSlick("#" + hashtag +" .sliders");

    } else {
       initializeSlick("#bundles .sliders");
    }



    // setup tab click
	$(".header-collection-link").click(function (event) {
        event.preventDefault();

		$(this).siblings().removeClass('active');
      	$(this).addClass('active');

      	// show relevant section
      	$(".tab-collection-panel").hide();

      	var hashtag = $(this).text().toLowerCase().trim();

        var collectionName = "#"+ hashtag+ "-panel";

      	if (hashtag  === 'accessories') {
      	    document.location.href ='/collections/accessories';
      	    return;
        }
      
      


        if (hashtag.indexOf('clearance')  >= 0 ) {
            document.location.href ='/collections/clearance';
            return;
        }

        if (hashtag.indexOf('50')  >= 0 ) {
            document.location.href ='/collections/studio-bundles';
            return;
        }



        if (hashtag.indexOf('clip')  >= 0 ) {
            document.location.href ='/collections/clip-in-tape-in-extensions';
            return;
        }

        if (hashtag.indexOf('tape-in')  >= 0 ) {
            document.location.href ='/products/tape-extensions';
            return;
        }
      
         if (hashtag.indexOf('store')  >= 0 ) {
            document.location.href ='/pages/hair-stores';
            return;
        }



        if (location.pathname !== "/") {
            document.location.href = '/#' + hashtag;
        }

      	$(collectionName).show();

      	// show relevant navbar
      	$(".custom-desktop-nav").removeClass('active');

      	var nativeName = "#"+ hashtag + "_desktop_nav";
      	$(nativeName).addClass('active');

        initializeSlick("#" + hashtag +" .sliders");
    });
})
